import React, { useState, useCallback } from 'react';
import Icon from '../../Icon';
import { translate } from '../../../Services/translation';
import clsx from 'clsx';
import Input from '../../Input';
import { useDispatch } from 'react-redux';
import { searchFacetChange } from '../../../Actions/FacetedSearch.action';

const FILTERS_TO_SHOW = 7;

const FilterCollapsible = ({ title, filter }) => {
  const [isOpen, setIsOpen] = useState(true); // Open by default
  const [optionsExpanded, setOptionsExpanded] = useState(false);
  const dispatch = useDispatch();

  const toggleCollapsible = () => {
    setIsOpen(!isOpen);
    setOptionsExpanded(false);
  };

  const handleFilterChange = useCallback((filter, option) => {
    dispatch(searchFacetChange(filter, option));
  }, []);

  // Filter options to only include those with quantity > 0
  const validOptions = filter.options.filter((option) => option.quantity > 0);

  return (
    <div className="filter-collapsible">
      <button
        className="filter-collapsible__header"
        aria-expanded={isOpen}
        aria-label={translate(
          isOpen ? 'product.filters.expanded.sc' : 'product.filters.hidden.sc'
        )}
        onClick={toggleCollapsible}
      >
        <div className="filter-collapsible__label">{title}</div>
        <Icon
          name="Caret-Down"
          size={24}
          className={clsx(
            'filter-collapsible__toggle-icon',
            isOpen ? 'open' : ''
          )}
        />
      </button>
      {isOpen && (
        <div className="filter-collapsible__filters-wrapper">
          <div
            className={clsx(
              'filter-collapsible__filters',
              validOptions.length >= FILTERS_TO_SHOW
                ? !optionsExpanded
                  ? 'filter-collapsible__filters--expandable'
                  : 'filter-collapsible__filters--expanded'
                : null
            )}
            aria-hidden={!isOpen}
          >
            {validOptions.map((option) => (
              <Input
                id={option.id}
                type="checkbox"
                wrapperClassName="filter-collapsible__filter"
                className="filter-collapsible__checkbox"
                checked={filter.selectedOptions.includes(option.id)}
                onChange={() => handleFilterChange(filter, option)}
                label={option.label}
                key={option.id}
              />
            ))}
          </div>
          {validOptions.length > FILTERS_TO_SHOW && (
            <button
              className="filter-collapsible__expand-btn"
              onClick={() => setOptionsExpanded(!optionsExpanded)}
            >
              {translate(
                optionsExpanded
                  ? 'product.filters.condense'
                  : 'product.filters.expand'
              )}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default FilterCollapsible;
